module.exports = __webpack_public_path__ + "img/高新技术企业证书.987d1bb8.png";